import React from 'react'
import styles from './influencerSec.module.css'
import { Images } from 'lucide-react'
import { becomeMaster, contCre, InfluencerBoostImg } from '../../../assets'
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import useTextAnimation from "../../hooks/useTextAnimation.js";
import { Link } from 'react-router-dom';
import { IMAGE_URL } from '../../helpers/api_helper.jsx';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_AR, LANG_EN } from '../../helpers/constant';
import Loading from '../loading/Loading.jsx';

const InfluencerBecomeMaster = ({influencerData}) => {
    const { ref: headingRef, inView: headingInView, textAnimation } = useTextAnimation();
    const { ref: paragraphRef, inView: paragraphInView } = useTextAnimation();
    const { t, i18n } = useTranslation();
    return (
        <div className={styles.influencerBoostCont}>
            <div className={`${styles.influencerBoostInner} ${i18n.language===LANG_AR?'arab':''} ${styles.influencerBoostInnerB}`}>
                <div className={`${styles.influencerBoostTitle} `}>
                    <motion.h3
                        ref={headingRef}
                        initial="hidden"
                        animate={headingInView ? "visible" : "hidden"}
                        custom={0}
                        variants={textAnimation}
                        /* dangerouslySetInnerHTML={{__html : influencerData?.footerBannerText}} */
                        dangerouslySetInnerHTML={{__html : i18n.language === LANG_EN ? influencerData?.footerBannerText : influencerData?.footerBannerTextAr}}
                    >{/* Contact Us */}</motion.h3>
                    <Link to="mailto:Partnerships@magnitudecreative.com">
                        <motion.div className={styles.influencerBoostLk}
                            ref={paragraphRef}
                            initial="hidden"
                            animate={paragraphInView ? "visible" : "hidden"}
                            custom={3}
                            variants={textAnimation}>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="65.178" height="40.563" viewBox="0 0 65.178 40.563">
                                    <g id="Group_11165" data-name="Group 11165" transform="translate(-116.127 -6544.976)">
                                        <path id="Path_16119" data-name="Path 16119" d="M136.83,41.362q12.851,0,25.7,0c4.8,0,6.766,1.951,6.772,6.73q.016,13.548,0,27.1c-.008,4.8-1.833,6.683-6.566,6.691q-26.309.043-52.618.032c-3.711,0-5.965-2.249-5.973-5.917q-.03-14.255,0-28.511c0-3.9,2.232-6.124,6.176-6.128q13.256-.013,26.511,0v.007M165.508,43.7h-57a7.488,7.488,0,0,0,.689.909c8.757,7.674,17.544,15.313,26.254,23.04,1.263,1.121,1.92.536,2.852-.273,6.811-5.91,13.652-11.784,20.468-17.687,2.114-1.83,4.182-3.713,6.739-5.989m-57.55,35.475c2.54,1.047,56.072.822,57.287-.1-.068-.111-.109-.264-.207-.328C158.4,74.386,151.779,70,145.085,65.729a2.505,2.505,0,0,0-2.187.416c-2.108,1.645-4.091,3.449-6.157,5.227-2-1.73-3.969-3.268-5.724-5.022-1.152-1.15-2-1.1-3.276-.244-4.973,3.34-10.016,6.575-15.025,9.861-1.542,1.012-3.061,2.061-4.76,3.207m-1.542-1.535L127.871,63.63,106.9,45.3l-.484.307Zm60.637-32.5-10.919,9.463-10.412,9.024,21.331,13.912Z" transform="translate(11.992 6503.623)" />
                                    </g>
                                </svg>

                            </span>
                           {/*  <p>Partnerships@magnitudecreative.com</p> */}
                           <p dangerouslySetInnerHTML={{__html : influencerData?.footerBannerEmail}}></p>
                        </motion.div>
                    </Link>
                    <motion.div className={styles.influencerBoostLkM}
                        ref={paragraphRef}
                        initial="hidden"
                        animate={paragraphInView ? "visible" : "hidden"}
                        custom={3}
                        variants={textAnimation}>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="34.467" height="61.986" viewBox="0 0 34.467 61.986">
                                <g id="Group_11166" data-name="Group 11166" transform="translate(-131.481 -6629.976)">
                                    <path id="Path_16120" data-name="Path 16120" d="M34.466,31.077q0,12.887,0,25.774c0,3.248-1.884,5.132-5.143,5.133q-12.162,0-24.324,0A4.628,4.628,0,0,1,.141,58.453a6.468,6.468,0,0,1-.135-1.511Q0,30.986,0,5.03C0,1.852,1.872,0,5.07,0Q17.2,0,29.321,0c3.212,0,5.145,1.939,5.145,5.155q0,12.96,0,25.919M2.31,52.705H31.99V9.2H2.31ZM17.186,55.09a2.331,2.331,0,0,0-2.262,2.274,2.267,2.267,0,0,0,4.533-.009,2.329,2.329,0,0,0-2.271-2.264m0-50q2.1,0,4.207,0c.4,0,.843-.009.854-.54s-.421-.572-.83-.573H12.934c-.4,0-.837.031-.851.555-.014.545.419.558.826.557q2.14,0,4.28,0" transform="translate(131.481 6629.975)" />
                                </g>
                            </svg>
                        </span>
                        {/* <p>+971582557764 / +971 50 855 8973</p> */}
                        <p dangerouslySetInnerHTML={{ __html: `${influencerData?.footerBannerContact1} / ${influencerData?.footerBannerContact2}` }}></p>

                    </motion.div>
                    {/* <motion.p
                        ref={paragraphRef}
                        initial="hidden"
                        animate={paragraphInView ? "visible" : "hidden"}
                        custom={1}
                        variants={textAnimation}
                        dangerouslySetInnerHTML={{ __html: configData.infDescription }}
                    ></motion.p> */}
                </div>
                <div className={styles.influencerBoostImg}>
                   {/*  <img src={becomeMaster} alt="" /> */}
                     <img src={`${IMAGE_URL}/influencer/${influencerData?.footerBannerImage}`  } />
                </div>
            </div>
        </div>
    )
}

export default InfluencerBecomeMaster
